export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          新片推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          本周最值得一看的热门影片，影迷都在追
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {/* Card 1 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20dramatic%20sci-fi%20astronaut%20floating%20in%20deep%20space%20with%20distant%20galaxy%2C%20dark%20cosmic%20background%20with%20vibrant%20nebula%20colors%2C%20professional%20Hollywood%20poster%20aesthetic%2C%20epic%20composition%20with%20strong%20contrast%20lighting&width=600&height=900&seq=card-movie-01&orientation=portrait"
                alt="星际穿越2：新纪元"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="600"
                height="900"
              />
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 font-bold">
                9.2
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">星际穿越2：新纪元</h3>
              <p className="text-xs text-foreground-500 mt-1">科幻 · 2026</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Action%20movie%20poster%20style%2C%20lone%20warrior%20silhouette%20against%20burning%20city%20skyline%2C%20dramatic%20orange%20and%20red%20explosion%20background%2C%20intense%20survival%20theme%2C%20professional%20movie%20poster%20design%20with%20gritty%20texture&width=600&height=900&seq=card-movie-02&orientation=portrait"
                alt="疾速追杀5"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="600"
                height="900"
              />
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 font-bold">
                8.8
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">疾速追杀5</h3>
              <p className="text-xs text-foreground-500 mt-1">动作 · 2026</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%20style%2C%20two%20friends%20laughing%20in%20a%20chaotic%20funny%20situation%20with%20bright%20colorful%20background%2C%20warm%20and%20vibrant%20lighting%2C%20playful%20and%20joyful%20atmosphere%2C%20professional%20Chinese%20comedy%20movie%20poster%20design&width=600&height=900&seq=card-movie-03&orientation=portrait"
                alt="夏洛特烦恼2"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="600"
                height="900"
              />
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 font-bold">
                8.5
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">夏洛特烦恼2</h3>
              <p className="text-xs text-foreground-500 mt-1">喜剧 · 2026</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20style%2C%20mysterious%20detective%20standing%20in%20dimly%20lit%20alley%20with%20fog%20and%20shadows%2C%20dark%20moody%20atmosphere%20with%20single%20streetlamp%20light%2C%20film%20noir%20aesthetic%2C%20professional%20crime%20movie%20poster%20design&width=600&height=900&seq=card-movie-04&orientation=portrait"
                alt="消失的真相"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="600"
                height="900"
              />
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 font-bold">
                9.0
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">消失的真相</h3>
              <p className="text-xs text-foreground-500 mt-1">悬疑 · 2026</p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20style%2C%20magical%20underwater%20kingdom%20with%20colorful%20coral%20reefs%20and%20friendly%20sea%20creatures%2C%20vibrant%20turquoise%20and%20coral%20color%20palette%2C%20dreamy%20fantasy%20atmosphere%20with%20sunlight%20rays%2C%20professional%20animated%20feature%20film%20poster%20design&width=600&height=900&seq=card-movie-05&orientation=portrait"
                alt="海洋奇缘3"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="600"
                height="900"
              />
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 font-bold">
                8.7
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">海洋奇缘3</h3>
              <p className="text-xs text-foreground-500 mt-1">动画 · 2026</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}